export default {
  isEnableABTestQuiz: (state) => {
    if (!state.presentation) return false
    if (state.presentation.userId % 10 > 2) return true
    return false
  },
}
